import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import './productHighlights.less'
export default {
    name: "productHighlights",
    data() {
        return {
            info: [
                {
                    pic: 'img/productHighlights/h2.png',
                    txt: '向支付机构、软件厂商开放数字化能力，助力企业快速升级为数字商业平台',
                    linkType: 'href',
                    linkTxt: '阅读开发者文档',
                    linkHref: 'https://www.showdoc.com.cn/liantuofu?page_id=721259087608792'
                },
                {
                    pic: 'img/productHighlights/h1.png',
                    txt: '向优秀服务商开放OEM平台级能力，轻松打造属于自己的移动支付业务平台',
                    linkType: 'href',
                    linkTxt: '阅读开发者文档',
                    linkHref: 'https://www.showdoc.com.cn/liantuofu?page_id=721259087608792'
                },
                {
                    pic: 'img/productHighlights/h3.png',
                    txt: '向集团性加盟连锁客户，开放聚合支付、数字营销、资金结算清算能力，助力打造企业自己的连锁业务中台',
                    linkType: 'href',
                    linkTxt: '阅读开发者文档',
                    linkHref: 'https://www.showdoc.com.cn/liantuofu?page_id=721259087608792'
                }
            ],
            topPic: [
                {
                    title: '支付超市',
                    pic: 'img/productHighlights/z1.png',
                    tip: '让支付选择更多样',
                    info: '一站式轻松接入官方、银行、三方、四方等，共计30余条支付通道，只需简单配置即可使用。通道选择更多样，结算方式更多元，费率调整更自由，还有各种通道奖励政策。'
                },
                {
                    title: '各类型API接口',
                    pic: 'img/productHighlights/z2.png',
                    tip: '满足各种支付接口需求',
                    info: '开放20余个API接口：包括集合支付API、主扫API、被扫API、公众号支付API、小程序支付API等；服务商端包括进件API、数据统计API、会员API、营销API等，满足所有场景的接口需求。'
                },
                {
                    title: '轻松接入',
                    pic: 'img/productHighlights/z6.png',
                    tip: '告别繁琐流程高效接入',
                    info: '成熟的支付接口文档，专业的对接团队，业务规则高度集成，满足合作伙伴基础支付业务增值服务无需自行开发，已经成功对接上百合作伙伴，最快1天完成开通，让对接更简单！'
                },
                {
                    title: '数字化能力',
                    pic: 'img/productHighlights/z4.png',
                    tip: '赋能企业数字化升级',
                    info: '从门店引流聚客，到会员运营，变现增长，帮助企业数字化自己的数据资产，构建自有的私域流量，从而更轻松实现业绩增长...合作伙伴、软件厂商，可以直接接入数字化能力，节约高额开发费用，快速实现软件的数字化升级。'
                },
                {
                    title: '领先资金结算清算能力',
                    pic: 'img/productHighlights/z5.png',
                    tip: '构建连锁加盟企业专属业务中台',
                    info: '连锁业务中台是联拓数科面向连锁加盟企业推出的一站式门店数字化SaaS系统解决方案，让客户能够高效地运营自己的私域流量、管理多家直营或加盟门店的资金结算和清算。'
                },
                {
                    title: '全面支持OEM',
                    pic: 'img/productHighlights/z3.png',
                    tip: '轻松拥有自己的移动支付业务平台',
                    info: '支持前端OEM：前端小精灵插件、收款设备、小程序、APP；支持后端OEM:商户后台、服务商后台；支持OEM二级代理商管理体系：后台、数据管理、费率管理、返佣管理等能力...让合作伙伴可以轻松拥有一个属于自己的四方平台！'
                }
            ],
            fast: {
                title: '快速启动',
                tip: '查看开发者文档，对接企业多样化需求',
                info: [
                    '通过开放的标准化API接口，可为商家迅速搭建场景应用，满足支付业务增值服务，提升技术开发效率。',
                    '接入联拓富开放平台意味着轻松的接入、简单的维护，我们更加注重核心客户和产品体验。'
                ],
                list: [
                    '支付、营销等全方位的能力',
                    '完善的API文档示例说明',
                    '安全对接，数据实时监控',
                    '支持多语言SDK：JAVA、PHP、C++等'
                ]
            },
            card: [
                {
                    pic: 'img/productHighlights/h4.png',
                    title: '安全与合理性',
                    info: '联拓数科是中国支付清算协会会员，获得信息系统安全等保2级证书，<br />ICP许可证书记忆19个软注，为您提供金融级别的企业安全服务。',
                    linkType: 'router',
                    linkHref: '/lianTuoCompany',
                    linkTxt: '关于我们'
                },
                {
                    pic: 'img/productHighlights/h5.png',
                    title: '合作费',
                    info: '我们所有的API和SDK都可供开发人员使用。<br />平方收取OEM费用及软件服务费和支付费率成本。',
                    linkType: 'href',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# ',
                    linkTxt: '联系我们了解完整价格'
                }
            ],
            certificate: [
                {
                    src: "img/productHighlights/2.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/3.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/4.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/5.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/6.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/7.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/8.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/9.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/10.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/11.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/12.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/13.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/14.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/15.png",
                    size: 3,
                },
                {
                    src: "img/productHighlights/16.png",
                    size: 4,
                },
                {
                    src: "img/productHighlights/17.png",
                    size: 4,
                },
                {
                    src: "img/productHighlights/18.png",
                    size: 4,
                }
            ],
            data: {
                title1: '联拓富开放平台',
                info1: '联拓数科面向支付机构、软件厂商、集团性连锁、银行等客户，开放我们的一站式移动支付解决方案，让客户能够轻松构建自己的商业支付平台。',
                linkType1: 'href',
                linkTxt1: '联系我们',
                linkHref1: 'https://www.wjx.cn/vm/QMNCfd2.aspx# ',
                title2: '一个平台<br/>为增长而建',
                info2: '加入我们，构建企业一站式移动支付解决方案，赋能商业，助力增长。',
                title3: '接入指南<br />成熟文档快速接入',
                info3: '加入我们，只需简单4步',
                linkType3: 'href',
                linkTxt3: '联系我们',
                linkHref3: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                title4: '合作伙伴',
                info4: '和众多合作伙伴一起，轻松构建自己的商业平台',
                linkType4: 'href',
                linkTxt4: '联系我们',
                linkHref4: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
            },
            partner: [
                {
                    src: "/img/productHighlights/logo1.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo2.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo3.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo4.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo5.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo6.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo7.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo8.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo9.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo10.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo11.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo12.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo13.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo14.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo15.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo16.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo17.png",
                    size: 1,
                },
                {
                    src: "/img/productHighlights/logo18.png",
                    size: 1,
                },
            ]
        }
    },
    components: {
        skeleton,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
